module.exports = __webpack_public_path__ + "static/img/p18.c6e4655.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/p18.png
// module id = odd+
// module chunks = 0